import { AbstractControl, FormArray } from '@angular/forms';

export function trimTrailingEmptyFormArrayRows(
  formArray: FormArray,
  isEmptyRow: (row: AbstractControl) => boolean,
): number {
  let removedCount = 0;

  while (formArray.length > 0) {
    const lastRow = formArray.at(formArray.length - 1);
    if (!isEmptyRow(lastRow)) {
      break;
    }

    formArray.removeAt(formArray.length - 1);
    removedCount++;
  }

  return removedCount;
}
